import dayJs from 'dayjs';
import moment from 'moment';

export const dateAndTimeFormat = 'yyyy/MM/DD HH:mm';

export function formatDateTime(value: string | null) {
	return value ? moment(value).format(dateAndTimeFormat) : value;
}

export function formatDate(value: string | null) {
	return value ? dayJs(value).format('yyyy/MM/dd'.toUpperCase()) : value;
}

export function formatTime(value: string | null) {
	 return value ? dayJs(value).format('HH:mm') : value;
}
export function formatMonthYear(value: string | null) {
	return value ? dayJs(value).format('yyyy-MM') : value;
}
export function formatMonthYearandtime(value: any | null) {
	const date = new Date(value);
	const year = date.getFullYear();
	const month = date.getMonth();
	const day = date.getDate();
	const Hour = date.getHours();
	const minutes = date.getMinutes();
	if (minutes !== null || Hour !== null || minutes !== '' || Hour !== '') {
		return value ? `${dayJs(value).format('yyyy/MM/dd'.toUpperCase())}  ${dayJs(value).format('HH:mm')}` : value;
	}
	if (date === null) {
		return date;
	}

	return value ? dayJs(value).format('yyyy/MM/dd'.toUpperCase()) : value;
}
